import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Description, DoneButton, MoreInfoWrapper, Title } from "./styles";

import { PageContainer } from "containers/PageContainer/styles";
import getImageUrl from "utils/getImageUrl";
import WhatHappensNext from "components/WhatHappensNext";
import { isFeatureActive } from "utils/getFeature";
import { selectOfferByPartner } from "state/offers-slice";
import Offer from "types/Offer";

const MoreInfo: FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { partnerName } = useParams<{ partnerName?: string }>();
  const selectedOffer: Offer | undefined = useSelector(selectOfferByPartner(partnerName));
  const location = useLocation();

  const isAgency = selectedOffer?.marketplaceInfo?.agency || location.pathname === "/more-info/detail";
  const isPartnerReseller = !isAgency;

  const content = {
    title: isPartnerReseller ? t("Subscribing through Vodafone") : t("Setting up with partners"),
    description: isPartnerReseller
      ? t("You are subscribing to a subscription through Vodafone to enjoy all your subscriptions in one place.")
      : t(
          "To be able to add your subscriptions to your Vodafone bill, the set up should be completed after check out.",
        ),
    procedureSteps: [
      {
        text: t(
          "1. After purchase you will be re-directed to the website of the first Partner in your basket to setup your chosen service subscription.",
        ),
        img: getImageUrl("/images/icons/wallet.png"),
      },
      {
        text: t(
          "2. If you have other subscriptions to set-up then these can be found and setup from the Subscription+ home page.",
        ),
        img: getImageUrl("/images/icons/settings.png"),
      },
      {
        text: t("3. That's all there is to it, to enjoy all your subscriptions in one place!"),
        img: getImageUrl("/images/icons/play.png"),
      },
    ],
  };

  return (
    <PageContainer $maxWidth="100%">
      <MoreInfoWrapper>
        <Title data-testid="more-info-title">{content.title}</Title>
        <Description data-testid="more-info-description">{content.description}</Description>
        <WhatHappensNext content={content.procedureSteps} />
        <DoneButton
          data-testid="moreInfodoneButton"
          title={t(isFeatureActive("Enabled default theme") ? "Done" : "Confirm")}
          onClick={() => navigate(-1)}
        />
      </MoreInfoWrapper>
    </PageContainer>
  );
};

export default MoreInfo;
